//Server node js configuration

/* http://localhost:4000 */
/* https://depoly-work-file.onrender.com */

const production = 'https://dbcbakend.azurewebsites.net';
const azureProd = 'https://dbcbakend.azurewebsites.net';
const dev = 'http://localhost:4000';
const ContaboURL = 'http://149.102.155.124:4000';


const frontEnd = 'http://192.168.2.188:3000';
const frontEnd2 = 'https://admin-dbc.azurewebsites.net';


module.exports = {

    API_URL: dev,
    FrondEndURL: frontEnd2

}